import {
  AddIcon,
  Alert,
  Button,
  ExclamationTriangleIcon,
  Flex,
  Skeleton,
  Text,
} from "@fluentui/react-northstar";
import { dialog } from "@microsoft/teams-js";
import { SharedImageCardUrl } from "@teams/cards";
import { useEffect, useState } from "react";

import { useSurvey } from "../../../../../_shared/actions/useSurvey";
import { useTeamsContext } from "../../../../../_shared/state/TeamsContextProvider";
import { QnaQuestionForm } from "./QnaQuestionForm";

const TRACKING = "meeting-bubble";

export const QnaInformation: React.FC<{ surveyId: string }> = ({ surveyId }) => {
  const [isAsking, setIsAsking] = useState<boolean>();
  const { teamsContext } = useTeamsContext();
  const { survey, loadSurvey, surveyError } = useSurvey();

  useEffect(() => {
    loadSurvey(teamsContext, surveyId);
  }, [surveyId, loadSurvey, teamsContext]);

  if (surveyError) {
    return (
      <Alert
        danger
        icon={<ExclamationTriangleIcon />}
        content="There was a problem loading the Q&A information"
      />
    );
  }

  if (!survey) {
    return (
      <Skeleton animation="wave">
        <Flex column gap="gap.small">
          <Skeleton.Shape width="100%" />
          <Skeleton.Button />
        </Flex>
      </Skeleton>
    );
  }

  if (isAsking) {
    return (
      <QnaQuestionForm
        survey={survey}
        trackingSource={TRACKING}
        onCompleted={() => setIsAsking(false)}
      />
    );
  }

  return (
    <Flex column gap="gap.medium" style={{ height: "100%" }}>
      {survey.state !== "open" && (
        <Text content="This Q&amp;A is no longer open" align="center" size="large" />
      )}

      {survey.state === "open" && (
        <>
          <Text
            content="The host has started a Q&amp;A for this meeting!"
            align="center"
            size="large"
            color="brand"
            weight="bold"
          />
          <Text
            content="Select the Polly icon in this meeting toolbar to participate in the Q&amp;A."
            align="center"
            size="large"
          />

          <Flex.Item align="center">
            <Flex column hAlign="center" gap="gap.medium">
              <img
                src={SharedImageCardUrl.OPEN_SIDE_PANEL}
                alt="Open Polly side panel"
                height={75}
              />
            </Flex>
          </Flex.Item>

          <Flex.Item grow>
            <div>
              <Button
                primary
                fluid
                content="Submit a question now"
                icon={<AddIcon />}
                onClick={() => setIsAsking(true)}
              />
            </div>
          </Flex.Item>
        </>
      )}

      <Flex.Item push align="end">
        <Button content="Done" primary onClick={() => dialog.url.submit()} />
      </Flex.Item>
    </Flex>
  );
};
